var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileTypePdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_917_480005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6398 0H2.36017C1.05668 0 0 1.05668 0 2.36017V14.6398C0 15.9433 1.05668 17 2.36017 17H14.6398C15.9433 17 17 15.9433 17 14.6398V2.36017C17 1.05668 15.9433 0 14.6398 0Z",
    fill: "#D55140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.26116 9.22544V10.9594H2.24683V6.04077H4.16499C4.53333 6.04077 4.85916 6.10877 5.13966 6.24477C5.42016 6.38077 5.63549 6.5706 5.78566 6.81994C5.93583 7.06927 6.01233 7.3526 6.01233 7.66994C6.01233 8.1516 5.84799 8.53127 5.51649 8.80894C5.18783 9.0866 4.72883 9.22544 4.14799 9.22544H3.25833H3.26116ZM3.26116 8.40377H4.16499C4.43416 8.40377 4.63816 8.34144 4.77699 8.21394C4.91866 8.08644 4.98949 7.90794 4.98949 7.67277C4.98949 7.4376 4.91866 7.23644 4.77699 7.08911C4.63533 6.94177 4.43983 6.86527 4.19049 6.8596H3.26116V8.40377Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.88211 10.9594V6.04077H8.39511C8.82861 6.04077 9.21394 6.13711 9.55677 6.33261C9.89961 6.52811 10.1631 6.80577 10.3558 7.16277C10.5484 7.52261 10.6419 7.93061 10.6419 8.38677V8.61344C10.6419 9.0696 10.5484 9.47761 10.3586 9.83177C10.1716 10.1888 9.90527 10.4636 9.56244 10.6591C9.21961 10.8546 8.83427 10.9538 8.40361 10.9566H6.87927L6.88211 10.9594ZM7.89644 6.86244V10.1463H8.38661C8.78327 10.1463 9.08644 10.0159 9.29611 9.7581C9.50577 9.50027 9.61344 9.12911 9.61627 8.64744V8.38677C9.61627 7.88811 9.51144 7.50844 9.30461 7.2506C9.09777 6.99277 8.79461 6.86244 8.39511 6.86244H7.89644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5095 8.9506H12.563V10.9594H11.5487V6.04077H14.7504V6.86244H12.5602V8.13177H14.5067V8.9506H14.5095Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_917_480005"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileTypePdf);
export default __webpack_public_path__ + "static/media/file-type-pdf.8b763c21eb7a109a85a13c38a76af858.svg";
export { ForwardRef as ReactComponent };